import React from 'react'

import './style/contact.css'

export default () => (
  <div>
    <div className='contact-hero'>
      <div className='contact-hero-img' />
    </div>
    <div className='sgeller-img-wrap'>
      <span className='sgeller-img' />
    </div>
    <div className='contact-title'>
      Steve Geller, CLFP
    </div>
    <div className='contact-content'>
      <div className='contact-labels'>
        phone
        <br />
        <br />
        fax
        <br />
        <br />
        cell
        <br />
        <br />
        email
      </div>
      <div className='contact-data'>
        <a className='contact-data-number' href='tel:+1-845-362-6106'>845.362.6106</a>
        <br />
        <a className='contact-data-number' href='tel:+1-815-642-0837'>815.642.0837</a>
        <br />
        <a className='contact-data-number' href='tel:+1-914-552-0842'>914.552.0842</a>
        <br />
        <a className='contact-data-email' href='mailto:sgeller@leasingsolutionsllc.com'>sgeller@leasingsolutionsllc.com</a>
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/pages/contact.js